/**
 * @Description: router入口文件
 * @Author: huping
 * @Date: 2021-08-06 11:07:15
 * @LastEditTime: 2021-08-26 16:19:30
 */

import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes'
import store from '@/store';
import {getStorage} from '@utils/storage'

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

let menuInited = false
// 登录路由控制(routes中设置路由meta.requireAuth)
router.beforeEach((to, from, next) => {
  let currentPage = {}
  const menuList = store.state.systemMenu.menuList
  if (menuList.length === 0 && !menuInited) {
    const updateType = getStorage('left-menu-type') || 'iot'
    if (to.path !== from.path) {
      // 获取auth
      store.dispatch('userInfo/updateAuthority')
      // 更新左侧菜单
      store.dispatch('systemMenu/updateMenuList', updateType).then(() => {
        menuInited = true
        next({
          ...to,
          replace: true
        })
      }).catch(() => {
        menuInited = false
        // 菜单初始化失败
        next({
          path: '/no-permission',
          replace: true
        })
      })
    }
  }
  const loop = (list) => {
    for (const item of list) {
      if (item.path === to.path) {
        currentPage = item
      }
      if (item.children && item.children.length) {
        loop(item.children)
      }
    }
  }
  // 鉴权
  const checkAuthor = (list) => {
    if (to.meta.requireAuth) {
      // list为已经初始化之后的菜单列表
      loop(list)
      // TODO 对currentPage鉴权，拦截跳转的务必return，如下：
      if (currentPage.name === 'index4') {
        router.replace('/no-permission')
        return
      }
    }
    store.dispatch('global/updatePreviousRouter', from);
    Vue.prototype.$sendPoint && Vue.prototype.$sendPoint.pageViewEvent(to, from);
    next()
  }
  if (menuList.length) {
    checkAuthor(menuList)
  } else {
    // 项目未完成初始化
    store.commit('systemMenu/menuUpdateHook', (menuList) => {
      checkAuthor(menuList)
    });
  }
});

export default router;

